var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"formTableContainer mt-3"},_vm._l((_vm.zusatzfelderKeys),function(key){return _c('div',{key:key},[_c('p',[_vm._v(_vm._s(key)+" = "+_vm._s(_vm.serviceKleberProperties.Zusatzfelder[key]))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }